import { GraphDealList } from "../graph/GraphDealList";
import { GraphDealShow } from "../graph/GraphDealShow";

export default {
  list: GraphDealList,
  show: GraphDealShow,
};
